import * as React from 'react';
import { IStyleConfig, mergeStyles } from '@cian/utils';
import * as styles from './RoundButton.css';

export type TRoundButtonType = 'normal' | 'big';

export interface IRoundButtonProps {
  children: React.ReactNode;
  buttonStyles?: IStyleConfig;
  onClick(): void;
}

export function RoundButton({ children, buttonStyles, onClick }: IRoundButtonProps) {
  return (
    <button {...mergeStyles(styles['button'], buttonStyles)} type="button" onClick={onClick}>
      {children}
    </button>
  );
}
